import React from 'react';
import { Input } from 'lib/releox-react';

export default () => (
  <>
    <Input name="barCode" label="Bar code" id="focus-input" />
  </>
);
